// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G815d","colBig":"styles_colBig__20RG4","colSmall":"styles_colSmall__2WJL2"};